import { c as _c } from "react/compiler-runtime";
import type { FC } from "react";
import type { NotePopulated } from "@vita-learning/types";
interface NoteItemProps {
  readonly note: NotePopulated;
}
export const NoteItem: FC<NoteItemProps> = t0 => {
  const $ = _c(2);
  const {
    note
  } = t0;
  let t1;
  if ($[0] !== note.title) {
    t1 = <div className="note-item"><div><h4>{note.title}</h4></div></div>;
    $[0] = note.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};